import React from "react";
import { ArrowUpRight, Database, Workflow, Monitor, Printer } from "lucide-react";

const ICONS = { Database, Workflow, Monitor, Printer };

export default function ServiceCard({ service, onOpen }) {
  const Icon = ICONS[service.icon] || Database;
  return (
    <article
      data-testid={`service-card-${service.id}`}
      className="card-lift group relative bg-[#0B0F19] border border-white/10 flex flex-col"
    >
      {/* Image */}
      <div className="relative overflow-hidden border-b border-white/10 aspect-[16/10]">
        <img
          src={service.image}
          alt={service.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19]/90 via-[#0B0F19]/20 to-transparent" />
        <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 bg-[#0B0F19]/80 border border-[#F47B20]/40 text-[#F47B20] text-[10px] font-bold uppercase tracking-[0.25em] backdrop-blur-md">
          {service.category}
        </div>
        <div className="absolute top-4 right-4 inline-flex items-center gap-2 px-3 py-1.5 bg-[#F47B20] text-black text-[10px] font-bold uppercase tracking-[0.25em]">
          {service.grade}
        </div>
        {service.tier === "primary" && (
          <div className="absolute bottom-4 right-4 inline-flex items-center gap-1.5 px-2.5 py-1 bg-[#F47B20] text-black text-[9px] font-bold uppercase tracking-[0.25em]">
            ★ Certified
          </div>
        )}
        <div className="absolute bottom-4 left-4 inline-flex items-center gap-2">
          <span className="inline-flex items-center justify-center w-10 h-10 bg-[#0B0F19]/80 border border-white/15 text-white">
            <Icon className="w-4 h-4" strokeWidth={2.2} />
          </span>
          <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-white/70">
            {service.weight}
          </span>
        </div>
      </div>

      {/* Body */}
      <div className="p-6 md:p-7 flex-1 flex flex-col">
        <h3 className="font-display text-2xl md:text-3xl font-bold text-white leading-tight">
          {service.name}
        </h3>
        <p className="mt-3 text-sm text-white/65 leading-relaxed">{service.short}</p>

        {/* Pills */}
        <div className="flex flex-wrap gap-2 mt-5">
          {service.features.slice(0, 4).map((f, i) => (
            <span
              key={i}
              className="inline-flex items-center px-2.5 py-1 border border-white/15 text-[10px] font-bold uppercase tracking-[0.2em] text-white/70"
            >
              {f}
            </span>
          ))}
        </div>

        {/* CTA */}
        <button
          type="button"
          onClick={() => onOpen(service)}
          data-testid={`service-card-cta-${service.id}`}
          className="mt-7 inline-flex items-center justify-between gap-3 px-5 py-3 border border-white/15 text-white font-bold uppercase tracking-[0.2em] text-xs hover:bg-[#F47B20] hover:text-black hover:border-[#F47B20] transition-colors"
        >
          View Details
          <ArrowUpRight className="w-4 h-4" />
        </button>
      </div>
    </article>
  );
}
